import { render, staticRenderFns } from "./modify_account.vue?vue&type=template&id=23ad2560&scoped=true"
import script from "./modify_account.vue?vue&type=script&lang=ts"
export * from "./modify_account.vue?vue&type=script&lang=ts"
import style0 from "./modify_account.vue?vue&type=style&index=0&id=23ad2560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad2560",
  null
  
)

export default component.exports